module.exports = __webpack_public_path__ + "public/img/ztpt.8a80cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ztpt.png
// module id = BUR1
// module chunks = 1